import React, { useState, useEffect } from 'react';
import './PendingResource.css';
import Body from '../../components/Body/Body';
import Formbox from '../../components/Formbox/Formbox';
import ShareGridient from '../../components/ShareGridient/ShareGridient';
import { useLocation } from 'react-router-dom';

const PendingResource = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const user_id = searchParams.get('user_id');

    const GetEmailConf = async () => {
        const BACKEND = process.env.REACT_APP_BACKEND_BASE; // Use environment variable for API endpoint 
        // const BACKEND = 'https://enrollment-be.dev.gridient.io'; // Replace with your actual API endpoint
        const url = `${BACKEND}/pending_resource_setups/${user_id}`;
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "User-Agent": "insomnia/11.0.1"
                }
                
            });
            const response_data = await response.json();
            var pending_resource_setups = response_data.pending_resources; 
            if (pending_resource_setups.length > 0) {
                window.location.href = pending_resource_setups[0].link;  
            }
        } catch (error) {
            console.error("API error:", error);
        }

    };
    useEffect(() => {
        GetEmailConf();
    }
    , []);
    return (
        <div>
            <Body elements={
                <Formbox elements={
                    <div>
                        <section>
                            <div className="inner">
                                <div className="wizard-header" style={{ textAlign: 'center' }}>
                                    <h1 style={{ color: 'green' }}>Thank You!</h1>
                                    <p>All Pending Resources Have Been Completed</p>
                                    <ShareGridient></ShareGridient>
                                </div>
                            </div>
                        </section>
                    </div>}
                ></Formbox>
            }></Body>
        </div>
    );
};

export default PendingResource;
